import $ from 'jquery'

export default function initPeople() {
  $('.js-collapse-button').on('click', function() {
    // Find closest .team__leadership and toggle the class is-active
    $(this).closest('.team__leadership').toggleClass('is-collapsed');
    $(this).text($(this).text() === 'Hide' ? 'View' : 'Hide');
  });
}
